import './styles.less';

import overviewTemplate from        './api.overview.template.pug';
import documentationTemplate from   './api.documentation.template.pug';

import generalTemplate from       './api.general.template.pug';

//import installTemplate from         './api.install.template.pug';

export default class TemplatesService {

	static get templates(){
		return {
			overview: overviewTemplate,
			documentation: documentationTemplate,

			auth: generalTemplate,
			account: generalTemplate,

			personalPanels: generalTemplate,
			personalItems: generalTemplate,

			personalAccessConnect: generalTemplate,
			personalAccessConfig: generalTemplate,
			personalAccessStatus: generalTemplate,
			personalAccessActions: generalTemplate,
			personalAccessInfo: generalTemplate,

			accessInstallTemplate: generalTemplate

		};
	}
	
}


/*
 console.log(pages.templates.auth)
 pages.templates.auth = '<h1>A</h1>'*/



/** WEBPACK FOOTER **
 ** ./src/main/apiTest/pages/index.js
 **/